import { useNavigate } from 'react-router-dom';
import { Alert, Button } from '@/shared/components';
import { PermissionGuard, useAuth } from '@/features/auth';
import { useProductsQuery } from '@/features/products/hooks/useProductsQuery';
import { DealerProductDataTable } from './DealerProductDataTable';

interface DealerProductsProps {
    dealerId: string;
}

export function DealerProducts({ dealerId }: DealerProductsProps) {
    const navigate = useNavigate();
    const { isInternal } = useAuth();
    const { data, isLoading, isError } = useProductsQuery({
        parent_dealer_id: dealerId,
        per_page: 25,
    });

    const products = data?.data ?? [];

    if (isError) {
        return (
            <Alert variant="error">
                <span>Failed to load products.</span>
            </Alert>
        );
    }

    return (
        <div className="space-y-6">
            <DealerProductDataTable data={products} isLoading={isLoading} canViewProduct={isInternal} />

            <div className="border-t border-mp-border pt-6 max-w-2xl">
                <h3 className="font-semibold mb-2">New Product</h3>
                <div className="flex items-start gap-4 justify-between">
                    <p className="text-sm text-mp-muted">
                        Create a new product owned by this dealer.
                    </p>
                    <PermissionGuard permission={{ resource: 'smr', action: 'product.add' }}>
                        <Button
                            size="sm"
                            variant="primary"
                            onClick={() => navigate(`/smr-admin/products/new?parent_dealer_id=${dealerId}`)}
                            className="whitespace-nowrap"
                        >
                            New Product
                        </Button>
                    </PermissionGuard>
                </div>
            </div>
        </div>
    );
}
